import {ButtonContext as $7705c033048f6da7$export$24d547caef80ccd1} from "./Button.mjs";
import {CheckboxContext as $ed8ccb2e23e76301$export$b085522c77523c51} from "./Checkbox.mjs";
import {DEFAULT_SLOT as $7230ffa83bc0c2cf$export$c62b8e45d58ddad9, dom as $7230ffa83bc0c2cf$export$df3a06d6289f983e, Provider as $7230ffa83bc0c2cf$export$2881499e37b75b9a, useContextProps as $7230ffa83bc0c2cf$export$29f1550f4b0d4415, useRenderProps as $7230ffa83bc0c2cf$export$4d86445c2cf5e3} from "./utils.mjs";
import {CollectionRendererContext as $263ab7fc0f95ccdb$export$4feb769f8ddf26c5, DefaultCollectionRenderer as $263ab7fc0f95ccdb$export$a164736487e3f0ae} from "./Collection.mjs";
import {DragAndDropContext as $f9554a667e4f0374$export$d188a835a7bc5783, DropIndicatorContext as $f9554a667e4f0374$export$f55761759794cf55, useDndPersistedKeys as $f9554a667e4f0374$export$d1e8e3fbb7461f6, useRenderDropIndicator as $f9554a667e4f0374$export$971707d8a129a1f7} from "./DragAndDrop.mjs";
import {FieldInputContext as $4b38b5b75ecc6208$export$698f465ec27e93df, SelectableCollectionContext as $4b38b5b75ecc6208$export$b0d3ecf7112093a7} from "./Autocomplete.mjs";
import {ListStateContext as $928221da08ecbc62$export$7c5906fe4f1f2af2} from "./ListBox.mjs";
import {SelectionIndicatorContext as $91fe5e721c7f36c1$export$c9549807523555e0} from "./SelectionIndicator.mjs";
import {SharedElementTransition as $792f28e438b9ad5f$export$758399f318e6385a} from "./SharedElementTransition.mjs";
import {TextContext as $efe09c6d1c304b50$export$9afb8bc826b033ea} from "./Text.mjs";
import {useGridList as $6XsrP$useGridList, useGridListItem as $6XsrP$useGridListItem, useGridListSelectionCheckbox as $6XsrP$useGridListSelectionCheckbox, useGridListSection as $6XsrP$useGridListSection} from "react-aria/useGridList";
import {Collection as $6XsrP$Collection} from "react-aria/Collection";
import {CollectionBuilder as $6XsrP$CollectionBuilder, createLeafComponent as $6XsrP$createLeafComponent, createBranchComponent as $6XsrP$createBranchComponent} from "react-aria/CollectionBuilder";
import {filterDOMProps as $6XsrP$filterDOMProps} from "react-aria/filterDOMProps";
import {FocusScope as $6XsrP$FocusScope} from "react-aria/FocusScope";
import {ItemNode as $6XsrP$ItemNode, LoaderNode as $6XsrP$LoaderNode, SectionNode as $6XsrP$SectionNode, HeaderNode as $6XsrP$HeaderNode} from "react-aria/private/collections/BaseCollection";
import {inertValue as $6XsrP$inertValue} from "react-aria/private/utils/inertValue";
import {ListKeyboardDelegate as $6XsrP$ListKeyboardDelegate} from "react-aria/ListKeyboardDelegate";
import {useListState as $6XsrP$useListState, UNSTABLE_useFilteredListState as $6XsrP$UNSTABLE_useFilteredListState} from "react-stately/useListState";
import {useLoadMoreSentinel as $6XsrP$useLoadMoreSentinel} from "react-aria/private/utils/useLoadMoreSentinel";
import {mergeProps as $6XsrP$mergeProps} from "react-aria/mergeProps";
import $6XsrP$react, {createContext as $6XsrP$createContext, forwardRef as $6XsrP$forwardRef, useContext as $6XsrP$useContext, useMemo as $6XsrP$useMemo, useRef as $6XsrP$useRef, useEffect as $6XsrP$useEffect} from "react";
import {useCollator as $6XsrP$useCollator} from "react-aria/useCollator";
import {useFocusRing as $6XsrP$useFocusRing} from "react-aria/useFocusRing";
import {useHover as $6XsrP$useHover} from "react-aria/useHover";
import {useLocale as $6XsrP$useLocale} from "react-aria/I18nProvider";
import {useObjectRef as $6XsrP$useObjectRef} from "react-aria/useObjectRef";
import {useVisuallyHidden as $6XsrP$useVisuallyHidden} from "react-aria/VisuallyHidden";

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



























const $1f7649abe3ae3599$export$54fe942636b6416d = /*#__PURE__*/ (0, $6XsrP$createContext)(null);
const $1f7649abe3ae3599$export$a7bfbda1311ca015 = /*#__PURE__*/ (0, $6XsrP$forwardRef)(function GridList(props, ref) {
    // Render the portal first so that we have the collection by the time we render the DOM in SSR.
    [props, ref] = (0, $7230ffa83bc0c2cf$export$29f1550f4b0d4415)(props, ref, $1f7649abe3ae3599$export$54fe942636b6416d);
    return /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $6XsrP$CollectionBuilder), {
        content: /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $6XsrP$Collection), props)
    }, (collection)=>/*#__PURE__*/ (0, $6XsrP$react).createElement($1f7649abe3ae3599$var$GridListInner, {
            props: props,
            collection: collection,
            gridListRef: ref
        }));
});
function $1f7649abe3ae3599$var$GridListInner({ props: props, collection: collection, gridListRef: ref }) {
    [props, ref] = (0, $7230ffa83bc0c2cf$export$29f1550f4b0d4415)(props, ref, (0, $4b38b5b75ecc6208$export$b0d3ecf7112093a7));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { shouldUseVirtualFocus: shouldUseVirtualFocus, filter: filter, disallowTypeAhead: disallowTypeAhead, ...DOMCollectionProps } = props;
    let { dragAndDropHooks: dragAndDropHooks, keyboardNavigationBehavior: keyboardNavigationBehavior = 'arrow', layout: layout = 'stack', orientation: orientation = 'vertical' } = props;
    let { CollectionRoot: CollectionRoot, isVirtualized: isVirtualized, layoutDelegate: layoutDelegate, dropTargetDelegate: ctxDropTargetDelegate } = (0, $6XsrP$useContext)((0, $263ab7fc0f95ccdb$export$4feb769f8ddf26c5));
    let gridlistState = (0, $6XsrP$useListState)({
        ...DOMCollectionProps,
        collection: collection,
        children: undefined,
        layoutDelegate: layoutDelegate
    });
    let filteredState = (0, $6XsrP$UNSTABLE_useFilteredListState)(gridlistState, filter);
    let collator = (0, $6XsrP$useCollator)({
        usage: 'search',
        sensitivity: 'base'
    });
    let { disabledBehavior: disabledBehavior, disabledKeys: disabledKeys } = filteredState.selectionManager;
    let { direction: direction } = (0, $6XsrP$useLocale)();
    let keyboardDelegate = (0, $6XsrP$useMemo)(()=>new (0, $6XsrP$ListKeyboardDelegate)({
            collection: filteredState.collection,
            collator: collator,
            ref: ref,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            layoutDelegate: layoutDelegate,
            layout: layout,
            orientation: orientation,
            direction: direction
        }), [
        filteredState.collection,
        ref,
        layout,
        orientation,
        disabledKeys,
        disabledBehavior,
        layoutDelegate,
        collator,
        direction
    ]);
    let { gridProps: gridProps } = (0, $6XsrP$useGridList)({
        ...DOMCollectionProps,
        keyboardDelegate: keyboardDelegate,
        // Only tab navigation is supported in grid layout.
        keyboardNavigationBehavior: layout === 'grid' ? 'tab' : keyboardNavigationBehavior,
        isVirtualized: isVirtualized,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        disallowTypeAhead: disallowTypeAhead
    }, filteredState, ref);
    let selectionManager = filteredState.selectionManager;
    let isListDraggable = !!dragAndDropHooks?.useDraggableCollectionState;
    let isListDroppable = !!dragAndDropHooks?.useDroppableCollectionState;
    let dragHooksProvided = (0, $6XsrP$useRef)(isListDraggable);
    let dropHooksProvided = (0, $6XsrP$useRef)(isListDroppable);
    (0, $6XsrP$useEffect)(()=>{
        if (process.env.NODE_ENV === 'production') return;
        if (dragHooksProvided.current !== isListDraggable) console.warn('Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.');
        if (dropHooksProvided.current !== isListDroppable) console.warn('Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.');
    }, [
        isListDraggable,
        isListDroppable
    ]);
    let dragState = undefined;
    let dropState = undefined;
    let droppableCollection = undefined;
    let isRootDropTarget = false;
    let dragPreview = null;
    let preview = (0, $6XsrP$useRef)(null);
    if (isListDraggable && dragAndDropHooks) {
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection: filteredState.collection,
            selectionManager: selectionManager,
            preview: dragAndDropHooks.renderDragPreview ? preview : undefined
        });
        dragAndDropHooks.useDraggableCollection({}, dragState, ref);
        let DragPreview = dragAndDropHooks.DragPreview;
        dragPreview = dragAndDropHooks.renderDragPreview ? /*#__PURE__*/ (0, $6XsrP$react).createElement(DragPreview, {
            ref: preview
        }, dragAndDropHooks.renderDragPreview) : null;
    }
    if (isListDroppable && dragAndDropHooks) {
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection: filteredState.collection,
            selectionManager: selectionManager
        });
        let dropTargetDelegate = dragAndDropHooks.dropTargetDelegate || ctxDropTargetDelegate || new dragAndDropHooks.ListDropTargetDelegate(collection, ref, {
            layout: layout,
            direction: direction,
            orientation: orientation
        });
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate: keyboardDelegate,
            dropTargetDelegate: dropTargetDelegate
        }, dropState, ref);
        isRootDropTarget = dropState.isDropTarget({
            type: 'root'
        });
    }
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $6XsrP$useFocusRing)();
    let isEmpty = filteredState.collection.size === 0;
    let renderValues = {
        isDropTarget: isRootDropTarget,
        orientation: orientation,
        isEmpty: isEmpty,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        layout: layout,
        state: filteredState
    };
    let renderProps = (0, $7230ffa83bc0c2cf$export$4d86445c2cf5e3)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-GridList',
        values: renderValues
    });
    let emptyState = null;
    let emptyStatePropOverrides = null;
    if (isEmpty && props.renderEmptyState) {
        let content = props.renderEmptyState(renderValues);
        emptyState = /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
            role: "row",
            "aria-rowindex": 1,
            style: {
                display: 'contents'
            }
        }, /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
            role: "gridcell",
            style: {
                display: 'contents'
            }
        }, content));
    }
    let DOMProps = (0, $6XsrP$filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $6XsrP$FocusScope), null, /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $7230ffa83bc0c2cf$export$df3a06d6289f983e).div, {
        ...(0, $6XsrP$mergeProps)(DOMProps, renderProps, gridProps, focusProps, droppableCollection?.collectionProps, emptyStatePropOverrides),
        ref: ref,
        slot: props.slot || undefined,
        onScroll: props.onScroll,
        "data-drop-target": isRootDropTarget || undefined,
        "data-empty": isEmpty || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-layout": layout,
        "data-orientation": orientation
    }, /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $7230ffa83bc0c2cf$export$2881499e37b75b9a), {
        values: [
            [
                (0, $928221da08ecbc62$export$7c5906fe4f1f2af2),
                filteredState
            ],
            [
                (0, $f9554a667e4f0374$export$d188a835a7bc5783),
                {
                    dragAndDropHooks: dragAndDropHooks,
                    dragState: dragState,
                    dropState: dropState
                }
            ],
            [
                (0, $f9554a667e4f0374$export$f55761759794cf55),
                {
                    render: $1f7649abe3ae3599$var$GridListDropIndicatorWrapper
                }
            ]
        ]
    }, isListDroppable && /*#__PURE__*/ (0, $6XsrP$react).createElement($1f7649abe3ae3599$var$RootDropIndicator, null), /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $792f28e438b9ad5f$export$758399f318e6385a), null, /*#__PURE__*/ (0, $6XsrP$react).createElement(CollectionRoot, {
        collection: filteredState.collection,
        scrollRef: ref,
        persistedKeys: (0, $f9554a667e4f0374$export$d1e8e3fbb7461f6)(selectionManager, dragAndDropHooks, dropState),
        renderDropIndicator: (0, $f9554a667e4f0374$export$971707d8a129a1f7)(dragAndDropHooks, dropState)
    }))), emptyState, dragPreview));
}
const $1f7649abe3ae3599$export$e96fc9a8407faa6b = /*#__PURE__*/ (0, $6XsrP$createLeafComponent)((0, $6XsrP$ItemNode), function GridListItem(props, forwardedRef, item) {
    let state = (0, $6XsrP$useContext)((0, $928221da08ecbc62$export$7c5906fe4f1f2af2));
    let { dragAndDropHooks: dragAndDropHooks, dragState: dragState, dropState: dropState } = (0, $6XsrP$useContext)((0, $f9554a667e4f0374$export$d188a835a7bc5783));
    let ref = (0, $6XsrP$useObjectRef)(forwardedRef);
    let { isVirtualized: isVirtualized } = (0, $6XsrP$useContext)((0, $263ab7fc0f95ccdb$export$4feb769f8ddf26c5));
    let { rowProps: rowProps, gridCellProps: gridCellProps, descriptionProps: descriptionProps, ...states } = (0, $6XsrP$useGridListItem)({
        node: item,
        shouldSelectOnPressUp: !!dragState,
        isVirtualized: isVirtualized
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $6XsrP$useHover)({
        isDisabled: !states.allowsSelection && !states.hasAction,
        onHoverStart: item.props.onHoverStart,
        onHoverChange: item.props.onHoverChange,
        onHoverEnd: item.props.onHoverEnd
    });
    let { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $6XsrP$useFocusRing)();
    let { checkboxProps: checkboxProps } = (0, $6XsrP$useGridListSelectionCheckbox)({
        key: item.key
    }, state);
    let buttonProps = state.selectionManager.disabledBehavior === 'all' && states.isDisabled ? {
        isDisabled: true
    } : {};
    let draggableItem = null;
    if (dragState && dragAndDropHooks) draggableItem = dragAndDropHooks.useDraggableItem({
        key: item.key,
        hasDragButton: true
    }, dragState);
    let dropIndicator = null;
    let dropIndicatorRef = (0, $6XsrP$useRef)(null);
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $6XsrP$useVisuallyHidden)();
    if (dropState && dragAndDropHooks) dropIndicator = dragAndDropHooks.useDropIndicator({
        target: {
            type: 'item',
            key: item.key,
            dropPosition: 'on'
        }
    }, dropState, dropIndicatorRef);
    let isDragging = dragState && dragState.isDragging(item.key);
    let renderProps = (0, $7230ffa83bc0c2cf$export$4d86445c2cf5e3)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-GridListItem',
        values: {
            ...states,
            isHovered: isHovered,
            isFocusVisible: isFocusVisible,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior,
            allowsDragging: !!dragState,
            isDragging: isDragging,
            isDropTarget: dropIndicator?.isDropTarget,
            id: item.key,
            state: state
        }
    });
    let dragButtonRef = (0, $6XsrP$useRef)(null);
    (0, $6XsrP$useEffect)(()=>{
        if (dragState && !dragButtonRef.current) console.warn('Draggable items in a GridList must contain a <Button slot="drag"> element so that keyboard and screen reader users can drag them.');
    // eslint-disable-next-line
    }, []);
    (0, $6XsrP$useEffect)(()=>{
        if (!item.textValue && process.env.NODE_ENV !== 'production') console.warn('A `textValue` prop is required for <GridListItem> elements with non-plain text children in order to support accessibility features such as type to select.');
    }, [
        item.textValue
    ]);
    let DOMProps = (0, $6XsrP$filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $6XsrP$react).Fragment, null, dropIndicator && !dropIndicator.isHidden && /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
        role: "row",
        style: {
            position: 'absolute'
        }
    }, /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
        role: "gridcell"
    }, /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicator?.dropIndicatorProps,
        ref: dropIndicatorRef
    }))), /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $7230ffa83bc0c2cf$export$df3a06d6289f983e).div, {
        ...(0, $6XsrP$mergeProps)(DOMProps, renderProps, rowProps, focusProps, hoverProps, draggableItem?.dragProps),
        ref: ref,
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-allows-dragging": !!dragState || undefined,
        "data-dragging": isDragging || undefined,
        "data-drop-target": dropIndicator?.isDropTarget || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode
    }, /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
        ...gridCellProps,
        style: {
            display: 'contents'
        }
    }, /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $7230ffa83bc0c2cf$export$2881499e37b75b9a), {
        values: [
            [
                (0, $ed8ccb2e23e76301$export$b085522c77523c51),
                {
                    slots: {
                        [(0, $7230ffa83bc0c2cf$export$c62b8e45d58ddad9)]: {},
                        selection: checkboxProps
                    }
                }
            ],
            [
                (0, $7705c033048f6da7$export$24d547caef80ccd1),
                {
                    slots: {
                        [(0, $7230ffa83bc0c2cf$export$c62b8e45d58ddad9)]: buttonProps,
                        drag: {
                            ...draggableItem?.dragButtonProps,
                            ref: dragButtonRef,
                            style: {
                                pointerEvents: 'none'
                            }
                        }
                    }
                }
            ],
            [
                (0, $efe09c6d1c304b50$export$9afb8bc826b033ea),
                {
                    slots: {
                        [(0, $7230ffa83bc0c2cf$export$c62b8e45d58ddad9)]: {},
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, $263ab7fc0f95ccdb$export$4feb769f8ddf26c5),
                (0, $263ab7fc0f95ccdb$export$a164736487e3f0ae)
            ],
            [
                (0, $928221da08ecbc62$export$7c5906fe4f1f2af2),
                null
            ],
            [
                (0, $4b38b5b75ecc6208$export$b0d3ecf7112093a7),
                null
            ],
            [
                (0, $4b38b5b75ecc6208$export$698f465ec27e93df),
                null
            ],
            [
                (0, $91fe5e721c7f36c1$export$c9549807523555e0),
                {
                    isSelected: states.isSelected
                }
            ]
        ]
    }, renderProps.children))));
});
function $1f7649abe3ae3599$var$GridListDropIndicatorWrapper(props, ref) {
    ref = (0, $6XsrP$useObjectRef)(ref);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $6XsrP$useContext)((0, $f9554a667e4f0374$export$d188a835a7bc5783));
    let buttonRef = (0, $6XsrP$useRef)(null);
    let { dropIndicatorProps: dropIndicatorProps, isHidden: isHidden, isDropTarget: isDropTarget } = dragAndDropHooks.useDropIndicator(props, dropState, buttonRef);
    if (isHidden) return null;
    return /*#__PURE__*/ (0, $6XsrP$react).createElement($1f7649abe3ae3599$var$GridListDropIndicatorForwardRef, {
        ...props,
        dropIndicatorProps: dropIndicatorProps,
        isDropTarget: isDropTarget,
        buttonRef: buttonRef,
        ref: ref
    });
}
function $1f7649abe3ae3599$var$GridListDropIndicator(props, ref) {
    let { dropIndicatorProps: dropIndicatorProps, isDropTarget: isDropTarget, buttonRef: buttonRef, ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $6XsrP$useVisuallyHidden)();
    let renderProps = (0, $7230ffa83bc0c2cf$export$4d86445c2cf5e3)({
        ...otherProps,
        defaultClassName: 'react-aria-DropIndicator',
        values: {
            isDropTarget: isDropTarget
        }
    });
    return /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $7230ffa83bc0c2cf$export$df3a06d6289f983e).div, {
        ...renderProps,
        role: "row",
        ref: ref,
        "data-drop-target": isDropTarget || undefined
    }, /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
        role: "gridcell"
    }, /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: buttonRef
    }), renderProps.children));
}
const $1f7649abe3ae3599$var$GridListDropIndicatorForwardRef = /*#__PURE__*/ (0, $6XsrP$forwardRef)($1f7649abe3ae3599$var$GridListDropIndicator);
function $1f7649abe3ae3599$var$RootDropIndicator() {
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $6XsrP$useContext)((0, $f9554a667e4f0374$export$d188a835a7bc5783));
    let ref = (0, $6XsrP$useRef)(null);
    let { dropIndicatorProps: dropIndicatorProps } = dragAndDropHooks.useDropIndicator({
        target: {
            type: 'root'
        }
    }, dropState, ref);
    let isDropTarget = dropState.isDropTarget({
        type: 'root'
    });
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $6XsrP$useVisuallyHidden)();
    if (!isDropTarget && dropIndicatorProps['aria-hidden']) return null;
    return /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
        role: "row",
        "aria-hidden": dropIndicatorProps['aria-hidden'],
        style: {
            position: 'absolute'
        }
    }, /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
        role: "gridcell"
    }, /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicatorProps,
        ref: ref
    })));
}
const $1f7649abe3ae3599$export$392b9a0bbc7c7e43 = (0, $6XsrP$createLeafComponent)((0, $6XsrP$LoaderNode), function GridListLoadingIndicator(props, ref, item) {
    let state = (0, $6XsrP$useContext)((0, $928221da08ecbc62$export$7c5906fe4f1f2af2));
    let { isVirtualized: isVirtualized } = (0, $6XsrP$useContext)((0, $263ab7fc0f95ccdb$export$4feb769f8ddf26c5));
    let { isLoading: isLoading, onLoadMore: onLoadMore, scrollOffset: scrollOffset, ...otherProps } = props;
    let sentinelRef = (0, $6XsrP$useRef)(null);
    let memoedLoadMoreProps = (0, $6XsrP$useMemo)(()=>({
            onLoadMore: onLoadMore,
            collection: state?.collection,
            sentinelRef: sentinelRef,
            scrollOffset: scrollOffset
        }), [
        onLoadMore,
        scrollOffset,
        state?.collection
    ]);
    (0, $6XsrP$useLoadMoreSentinel)(memoedLoadMoreProps, sentinelRef);
    let renderProps = (0, $7230ffa83bc0c2cf$export$4d86445c2cf5e3)({
        ...otherProps,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-GridListLoadingIndicator',
        values: undefined
    });
    // For now don't include aria-posinset and aria-setsize on loader since they aren't keyboard focusable
    // Arguably shouldn't include them ever since it might be confusing to the user to include the loaders as part of the
    // item count
    return /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $6XsrP$react).Fragment, null, /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
        style: {
            position: 'relative',
            width: 0,
            height: 0
        },
        inert: (0, $6XsrP$inertValue)(true)
    }, /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
        "data-testid": "loadMoreSentinel",
        ref: sentinelRef,
        style: {
            position: 'absolute',
            height: 1,
            width: 1
        }
    })), isLoading && renderProps.children && /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $7230ffa83bc0c2cf$export$df3a06d6289f983e).div, {
        ...renderProps,
        ...(0, $6XsrP$filterDOMProps)(props, {
            global: true
        }),
        role: "row",
        ref: ref
    }, /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
        "aria-colindex": isVirtualized ? 1 : undefined,
        role: "gridcell"
    }, renderProps.children)));
});
const $1f7649abe3ae3599$export$f696877219115b14 = /*#__PURE__*/ (0, $6XsrP$createBranchComponent)((0, $6XsrP$SectionNode), (props, ref, item)=>{
    let state = (0, $6XsrP$useContext)((0, $928221da08ecbc62$export$7c5906fe4f1f2af2));
    let { CollectionBranch: CollectionBranch } = (0, $6XsrP$useContext)((0, $263ab7fc0f95ccdb$export$4feb769f8ddf26c5));
    let headingRef = (0, $6XsrP$useRef)(null);
    ref = (0, $6XsrP$useObjectRef)(ref);
    let { rowHeaderProps: rowHeaderProps, rowProps: rowProps, rowGroupProps: rowGroupProps } = (0, $6XsrP$useGridListSection)({
        'aria-label': props['aria-label'] ?? undefined
    }, state, ref);
    let renderProps = (0, $7230ffa83bc0c2cf$export$4d86445c2cf5e3)({
        ...props,
        id: undefined,
        children: undefined,
        defaultClassName: 'react-aria-GridListSection',
        values: undefined
    });
    let DOMProps = (0, $6XsrP$filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $7230ffa83bc0c2cf$export$df3a06d6289f983e).div, {
        ...(0, $6XsrP$mergeProps)(DOMProps, renderProps, rowGroupProps),
        ref: ref
    }, /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $7230ffa83bc0c2cf$export$2881499e37b75b9a), {
        values: [
            [
                $1f7649abe3ae3599$export$87f5843bfb30d205,
                {
                    ...rowProps,
                    ref: headingRef
                }
            ],
            [
                $1f7649abe3ae3599$export$bc7e8a4031ec2a33,
                {
                    ...rowHeaderProps
                }
            ]
        ]
    }, /*#__PURE__*/ (0, $6XsrP$react).createElement(CollectionBranch, {
        collection: state.collection,
        parent: item
    })));
});
const $1f7649abe3ae3599$export$87f5843bfb30d205 = /*#__PURE__*/ (0, $6XsrP$createContext)({});
const $1f7649abe3ae3599$export$bc7e8a4031ec2a33 = /*#__PURE__*/ (0, $6XsrP$createContext)(null);
const $1f7649abe3ae3599$export$1b574dbdb0075ff6 = /*#__PURE__*/ (0, $6XsrP$createLeafComponent)((0, $6XsrP$HeaderNode), function Header(props, ref) {
    [props, ref] = (0, $7230ffa83bc0c2cf$export$29f1550f4b0d4415)(props, ref, $1f7649abe3ae3599$export$87f5843bfb30d205);
    let rowHeaderProps = (0, $6XsrP$useContext)($1f7649abe3ae3599$export$bc7e8a4031ec2a33);
    return /*#__PURE__*/ (0, $6XsrP$react).createElement((0, $7230ffa83bc0c2cf$export$df3a06d6289f983e).div, {
        render: props.render,
        className: "react-aria-GridListHeader",
        ref: ref,
        ...props
    }, /*#__PURE__*/ (0, $6XsrP$react).createElement("div", {
        ...rowHeaderProps,
        style: {
            display: 'contents'
        }
    }, props.children));
});


export {$1f7649abe3ae3599$export$54fe942636b6416d as GridListContext, $1f7649abe3ae3599$export$a7bfbda1311ca015 as GridList, $1f7649abe3ae3599$export$e96fc9a8407faa6b as GridListItem, $1f7649abe3ae3599$export$392b9a0bbc7c7e43 as GridListLoadMoreItem, $1f7649abe3ae3599$export$f696877219115b14 as GridListSection, $1f7649abe3ae3599$export$87f5843bfb30d205 as GridListHeaderContext, $1f7649abe3ae3599$export$bc7e8a4031ec2a33 as GridListHeaderInnerContext, $1f7649abe3ae3599$export$1b574dbdb0075ff6 as GridListHeader};
//# sourceMappingURL=GridList.mjs.map
